<template>
  <div class="library container bg-light">
    <div class="pt-4 mt-4 d-flex">
      <button
        type="button"
        class="btn btn-sm mr-1 btn-success"
        @click="saveBookAsync"
        v-bind:disabled="isDisabled"
      >
        Salva & Ritorna
      </button>
      <button
        type="button"
        @click="clickCancel"
        class="btn btn-sm mr-1 btn-danger"
      >
        Annulla
      </button>
    </div>
    <hr />

    <BookEdit :book="book" v-on:update:hasErrors="hasErrors = $event">
    </BookEdit>

    <div class="mb-4 pb-4"></div>
  </div>
</template>

<script>
import appService from "@/service.js";
import BookEdit from "@/components/BookEdit.vue";

export default {
  components: {
    BookEdit
  },
  data: function() {
    return {
      book: {
        id: "",
        nr_volumi: 1
      },
      errorElements: [],
      hasErrors: false
    };
  },
  methods: {
    checkInvalidElements(id) {
      var x = this.errorElements.findIndex(el => el.id == id);
      return x > -1;
    },
    checkForm: function() {
      this.errors = [];

      return this.errors.length === 0;
    },
    saveBookAsync() {
      if (this.errorElements.length != 0) {
        return;
      }

      appService
        .insertBook(this.book)
        .then(() => {
          //se ok
          this.$router.push("/library");
        })
        .catch(error => {
          //debugger
          alert(`Errore durante il salvataggio.\n${error.data}`);
        });
    },
    clickCancel() {
      this.$router.push({ name: "library" });
    }
  },
  computed: {
    isDisabled() {
      //return this.errorElements.length > 0
      return this.hasErrors;
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    console.log("getBooksMaxId() from parent");
    //trova il primo id disponibile
    appService.getBooksMaxId().then(res => {
      this.book.id = parseInt(res.data) + 1;
    });
  }
};
</script>

<style>
.form-group {
  margin-bottom: 0.2rem;
}
.form-control {
  font-size: 0.8rem;
}

table {
  text-align: left;
}
</style>
